import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function ReadyForTemptation() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Ready yourself and prepare for temptation" />
        <blockquote>
  “I buffet my body and make it my slave…lest I myself should be disqualified.” (1 Corinthians 9:27)
</blockquote>

<p>Temptation should not take us by surprise. We should expect it to come, and we should be preparing ourselves each day for the battle. We need to “see the evil and hide,” rather than proceeding and paying the penalty (Proverbs 22:3). For example, if you are tempted by lustful thoughts, know that you will be tempted if you go to a movie with lewd content or stare at a person or gaze at a magazine; these images may stay in your mind for days and cause you to struggle with temptation long after the initial exposure is over. This is one of the insidious problems with pornographic materials: the images can stay in our minds for days, weeks, or even years, and cause us to stumble day after day. We must prevent these images from being burned in our minds by simply refusing to look at them to begin with. Avoid movies and television where you expect immoral behavior and images; screen movies before going to them, and avoid movies that contain immorality and nudity. Be prepared to turn off the television immediately if commercials or programs come on that would make you or your children stumble. If you are tempted by alcohol or other things, avoid places where it is available and avoid even looking at pictures of alcoholic beverages. Anticipate how and when you will be tempted, and avoid exposing yourself to it.</p>
<br />

<blockquote>
  “Watch over your heart with all diligence, for from it flows the springs of life.” (Proverbs 4:23)
</blockquote>

<ul>
  <li>
    <strong>Put on the full armor of God. Prepare for the battle.</strong><br />
    <em>Ephesians 6:10-17, Romans 13:12</em>
  </li>
  <br />
  <li>
    <strong>“Watch over your heart with all diligence, for from it flow the springs of life.”</strong><br />
    <em>Proverbs 4:23</em>
  </li>
  <br />
  <li>
    <strong>See the evil, and hide yourself.</strong><br />
    <em>Proverbs 22:3, 27:12</em>
  </li>
  <br />
  <li>
    <strong>Establish habits of discipline of the mind and body. Run in such a way that you may win.</strong><br />
    <em>1 Corinthians 9:24-27</em>
  </li>
  <br />
  <li>
    <strong>Expect temptation to come and continually be on guard; prepare every morning to resist temptation.</strong><br />
    <em>Matthew 6:13, Ephesians 6:18, 1 Peter 5:8</em>
  </li>
  <br />
  <li>
    <strong>Plan in advance how you will gain the victory over temptation; envision yourself immediately and completely resisting temptation and saying no to sin; rehearse the Christ-like response.</strong><br />
    <em>Job 31:1, Psalm 17:3, 39:1, Psalm 50:14, 76:11, 119:57-59, Daniel 1:8</em>
  </li>
  <br />
  <li>
    <strong>Prepare to suffer in the flesh and do whatever else is necessary to avoid sin.</strong><br />
    <em>Job 13:15, Hebrews 12:4, 1 Peter 4:1-2</em>
  </li>
</ul>

      </div>
    </PageLayout>
  );
};
